module.exports = __webpack_public_path__ + "static/media/icon_saintDay_button_nor.86f077b9.png";